'use client';

import {
	Portal,
	Select,
	createListCollection,
} from '@chakra-ui/react';
import { useLocale, useTranslations } from 'next-intl';

import type { Locale } from '@/libs/i18n';

type Props = { onSelect: (locale: Locale) => void };

export const LocaleMenu = ({ onSelect }: Props) => {
	const locale = useLocale();
	const t = useTranslations();
	const localesCollection = createListCollection({
		items: [
			{ label: t('locale.en'), value: 'en' },
			{ label: t('locale.th'), value: 'th' },
		],
	});

	return (
		<Select.Root
			collection={localesCollection}
			defaultValue={[ locale ]}
			onValueChange={e => e.value[0] && onSelect(e.value[0] as Locale)}
			w="100px"
		>
			<Select.HiddenSelect />
			<Select.Control>
				<Select.Trigger>
					<Select.ValueText placeholder="-" />
				</Select.Trigger>
				<Select.IndicatorGroup>
					<Select.Indicator />
				</Select.IndicatorGroup>
			</Select.Control>
			<Portal>
				<Select.Positioner>
					<Select.Content>
						{localesCollection.items.map(item => (
							<Select.Item item={item} key={item.value}>
								{item.label}
								<Select.ItemIndicator />
							</Select.Item>
						))}
					</Select.Content>
				</Select.Positioner>
			</Portal>
		</Select.Root>
	);
};
